import React from 'react';
import SecondUserScreen from 'src/features/user/screens/SecondUser/SecondUserScreen';
import LeadScoreModal from 'src/features/company/components/LeadScore/LeadScoreModal';
import QuoteSuccessModal from './CallModals/QuoteSuccessModal';
import QuoteMethodModal from './CallModals/QuoteMethodModal';
import { Company } from '@typeRoots/common/company';
interface ModalsProps {
  secondUserModalVisible: boolean;
  leadModalVisible: boolean;
  setLeadModalVisible: (visible: boolean) => void;
  setDataFilledByModalVisible: (visible: boolean) => void;
  dataFilledByModalVisible: boolean;
  navigateToVehiclesTab?: () => void;
  dotNumber: string;
  company: Company | null;
}

const Modals: React.FC<ModalsProps> = ({
  secondUserModalVisible,
  leadModalVisible,
  setLeadModalVisible,
  setDataFilledByModalVisible,
  dataFilledByModalVisible,
  navigateToVehiclesTab,
  dotNumber,
  company,
}) => {
  const [isQuoteSuccessVisible, setQuoteSuccessVisible] = React.useState(false);

  return (
    <>
      {secondUserModalVisible && <SecondUserScreen dotNumber={dotNumber} />}
      {leadModalVisible && (
        <LeadScoreModal
          leadModalVisible={leadModalVisible}
          setLeadModalVisible={setLeadModalVisible}
        />
      )}
      {company && company.id > 0 && (
        <QuoteMethodModal
          isVisible={dataFilledByModalVisible}
          onClose={() => {
            setDataFilledByModalVisible(false);
          }}
          setQuoteSuccessVisible={setQuoteSuccessVisible}
          navigateToVehiclesTab={navigateToVehiclesTab}
          companyId={company?.id || 0}
        />
      )}
      {isQuoteSuccessVisible && (
        <QuoteSuccessModal
          isVisible={isQuoteSuccessVisible}
          onClose={() => {
            setQuoteSuccessVisible(false);
            if (navigateToVehiclesTab) {
              navigateToVehiclesTab();
            }
          }}
        />
      )}
    </>
  );
};

export default Modals;
